export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          影迷热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">听听影迷们怎么说，找到你的下一部心头好</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {/* Comment 1 */}
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-primary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Asian%20person%20portrait%20with%20warm%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20profile%20picture%20style&width=100&height=100&seq=comment-avatar-01&orientation=squarish"
                  alt="影迷头像"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">电影发烧友小王</div>
                <div className="text-xs text-foreground-400">2 小时前</div>
              </div>
            </div>
            <p className="text-xs text-foreground-600 leading-relaxed mb-2">
              桃子视频的片源更新速度真的快！昨天电影院刚上映的新片今天就能看了，画质还超清晰，再也不用来回跑影院了。
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 256</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 48</span>
            </div>
          </div>

          {/* Comment 2 */}
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-accent-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20woman%20portrait%20with%20warm%20smile%2C%20soft%20indoor%20lighting%2C%20clean%20background%2C%20friendly%20expression%2C%20profile%20picture&width=100&height=100&seq=comment-avatar-02&orientation=squarish"
                  alt="影迷头像"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">追剧少女阿琳</div>
                <div className="text-xs text-foreground-400">5 小时前</div>
              </div>
            </div>
            <p className="text-xs text-foreground-600 leading-relaxed mb-2">
              在这里找到了好多冷门高分日剧！以前找资源找到头秃，现在一个网站全搞定，香蕉视频和西瓜视频的资源都有。
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 189</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 35</span>
            </div>
          </div>

          {/* Comment 3 */}
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Mature%20man%20portrait%20with%20gentle%20expression%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20casual%20look%2C%20profile%20picture&width=100&height=100&seq=comment-avatar-03&orientation=squarish"
                  alt="影迷头像"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">老李聊电影</div>
                <div className="text-xs text-foreground-400">昨天</div>
              </div>
            </div>
            <p className="text-xs text-foreground-600 leading-relaxed mb-2">
              作为一个看了三十年电影的老影迷，真心觉得桃子视频的分类做得好。蜜桃视频的动作片、芒果视频的文艺片，各取所需。
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 312</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 67</span>
            </div>
          </div>

          {/* Comment 4 */}
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-primary-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20creative%20person%20portrait%20with%20casual%20style%2C%20warm%20natural%20light%2C%20clean%20background%2C%20friendly%20vibe%2C%20profile%20picture&width=100&height=100&seq=comment-avatar-04&orientation=squarish"
                  alt="影迷头像"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">二次元小陈</div>
                <div className="text-xs text-foreground-400">昨天</div>
              </div>
            </div>
            <p className="text-xs text-foreground-600 leading-relaxed mb-2">
              新番更新速度比某些专门动漫站还快！蓝莓视频那边的番剧资源太全了，每周追更全靠桃子视频，强烈安利！
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 203</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 42</span>
            </div>
          </div>

          {/* Comment 5 */}
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-accent-100 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Middle%20aged%20woman%20portrait%20with%20warm%20smile%2C%20soft%20lighting%2C%20clean%20background%2C%20friendly%20approachable%20look%2C%20profile%20picture&width=100&height=100&seq=comment-avatar-05&orientation=squarish"
                  alt="影迷头像"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">宝妈追剧日记</div>
                <div className="text-xs text-foreground-400">2 天前</div>
              </div>
            </div>
            <p className="text-xs text-foreground-600 leading-relaxed mb-2">
              带娃间隙全靠桃子视频续命！草莓视频那边的综艺特别全，不用缓冲太省心了，晚上哄娃睡觉后就是我的追综时间。
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 178</span>
              <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 29</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}